import appleUrl from "~/assets/js/appleid.auth.js?url";

const _initApple = (): Promise<void> => {
  return new Promise((reslove, reject) => {
    console.log(appleUrl);
    loadJSWidthUrl(appleUrl)
      .then((res) => {
        window?.AppleID?.auth?.init?.({
          clientId: import.meta.env.VITE_APPLE_APP_ID,
          scope: "email name",
          redirectURI: location.origin,
          usePopup: true,
        });
        reslove();
      })
      .catch((err) => {
        reject(err);
        window.initApple = null;
      });
  });
};

export const initAppleInit = () => {
  if (window.initApple) return window.initApple;
  window.initApple = _initApple();
  return window.initApple;
};
